/* Copyright (c) 2020 Paul Nebel */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';

import { obj as EventIconButton } from './event-icon-button';

class EventIconToggleButton extends EventIconButton {
    static getDerivedStateFromProps(nextProps, prevState) {
        const {
            buttonEvent,
            buttonClickedAt,
            buttonToggleState,
        } = nextProps;

        const newState = {
            ...prevState,
        };

        if ((buttonEvent === prevState.event) &&
            (buttonClickedAt !== prevState.buttonClickedAt) &&
            (buttonToggleState !== prevState.toggleState)) {
            newState.buttonClickedAt = buttonClickedAt;
            newState.toggleState = buttonToggleState;
        }

        if (!isEqual(prevState, newState)) {
            return newState;
        } else {
            return null;
        }
    }

    constructor (props, context) {
        super(props, context);

        this.state = {
            ...props,
        };
    }

    handleClicked() {
        // state hasn't been updated yet, and won't be until the message is dispatched
        this.props.notifyToggleButtonClicked(this.state.event, !this.state.toggleState);
    }

    addButtonContents() {
        const icon = this.state.toggleState ? this.props.trueIcon : this.props.falseIcon;
        const color = this.state.toggleState ? this.props.trueColor : this.props.falseColor;
        return (
            <i className={ `fas fa-${icon} is-size-5 mt-1` } style={{ color }}></i>
        );
    }
}

const mapStateToProps = ({
    buttonEvent,
    buttonClickedAt,
    buttonToggleState,
}) => {
    return {
        buttonEvent,
        buttonClickedAt,
        buttonToggleState,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        notifyToggleButtonClicked: (
            event,
            toggleState,
        ) => dispatch({
            type: `TOGGLE_CLICKED`,
            event,
            toggleState,
        }),
    };
};

EventIconToggleButton.propTypes = {
    ...EventIconButton.propTypes,
    toggleState: PropTypes.bool,
    buttonEvent: PropTypes.string,
    buttonClickedAt: PropTypes.number,
    trueIcon: PropTypes.string,
    trueColor: PropTypes.string,
    falseIcon: PropTypes.string,
    falseColor: PropTypes.string,
};

EventIconToggleButton.defaultProps = {
    ...EventIconButton.defaultProps,
    toggleState: false,
    trueIcon: 'circle',
    trueColor: '#dee5ed',
    falseIcon: 'circle',
    falseColor: '#3E4B59',
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(EventIconToggleButton);
